/* Pasform - close on outisde click */
var PDP__measurementsDropdown = (function () {
	var dropdown = document.querySelector('wdn-dropdown[data-id="model_mesaurements"]');
	if (!dropdown) return;
	var triggers = dropdown.querySelectorAll('.model_mesaurements-trigger');
	var dropdownInner = dropdown.querySelector('.product-measurements-bg');
	if (!dropdownInner) return;

	// Handlers
	var onInnerBlur = function () {
		dropdown.setInactive();

		triggers.forEach(function (elem) {
			elem.setAttribute('data-pointer-events-none', '');
		});

		setTimeout(function () {
			triggers.forEach(function (elem) {
				elem.removeAttribute('data-pointer-events-none');
			});
		}, 500);
	};

	var onTriggerClick = function () {
		if (dropdown.isActive == false) {
			dropdown.setActive();
			dropdownInner.focus();
		}
	};

	// Listeners
	dropdownInner.addEventListener('blur', onInnerBlur);

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', onTriggerClick);
	});
})();



var PDP__onBlankAddToCartClick = (function () {

	var btn = document.querySelector('[data-pdp-form-submit]');
	var productForm = btn && btn.closest('wdn-product-form');
	if (!productForm) {
		return {
			openNextStep: function () {
				return false;
			},
		};
	}

	function isDesktop() {
		return window.innerWidth >= 880;
	}

	function closeActiveModals(keepId) {
		document.querySelectorAll('wdn-modal').forEach(function (modal) {
			if (modal.isActive && modal.getAttribute('data-id') !== keepId) {
				modal.close();
			}
		});
	}

	function getFirstUnpickedVariantSelect() {
		var variantSelects = productForm.querySelectorAll("[data-select][data-id='product_page']:not([data-variant-select-one-option])");
		for (var i = 0; i < variantSelects.length; i++) {
			if (!variantSelects[i].selected_option) {
				return variantSelects[i];
			}
		}
		return null;
	}

	// TODO: Why are u using a completely different
	// way to check variant selected? And what ensures
	// there is only one addon select?

	function getUnchosenAddonSelect() {
		var variantSelect = productForm.querySelector("[data-select][data-id='product_page']");
		var selectedVariant = variantSelect && variantSelect.selectedVariant;
		if (selectedVariant && !selectedVariant.available) return null;

		var addonSelect = productForm.querySelector('wdn-addon-select');
		if (addonSelect && !addonSelect.selected_option) {
			return addonSelect;
		}
		return null;
	}

	function scrollToSelect(select) {
		var topOffset = parseFloat(getComputedStyle(select).scrollMarginTop) || 0;
		var rect = select.getBoundingClientRect();
		if (rect.top >= topOffset && rect.bottom <= window.innerHeight) return;

		select.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	function expandInlineSelect(select) {
		closeActiveModals();
		productForm.querySelectorAll('[data-select]').forEach(function (other) {
			if (other !== select && other.isActive) other.shrinkContainer();
		});
		setTimeout(function () {
			select.expandContainer();
			scrollToSelect(select);
		}, 0);
	}

	function openVariantStep(variantSelect) {
		if (isDesktop()) {
			expandInlineSelect(variantSelect);
			return;
		}

		closeActiveModals('mobile_variant_select');
		variantSelect.querySelector('wdn-modalvariant-trigger').click();
	}

	function openAddonStep(addonSelect) {
		if (isDesktop()) {
			expandInlineSelect(addonSelect);
			return;
		}

		closeActiveModals('mobile_addon_select');
		addonSelect.querySelector('wdn-modaladdon-trigger').click();
	}

	function markError(select) {
		select.removeAttribute('data-error');
		void select.offsetWidth;
		select.setAttribute('data-error', '');
	}

	function markMissingSelects() {
		productForm.querySelectorAll("[data-select][data-id='product_page']:not([data-variant-select-one-option])").forEach(function (select) {
			if (!select.selected_option) markError(select);
		});

		var addonSelect = getUnchosenAddonSelect();
		if (addonSelect) markError(addonSelect);
	}

	function openNextStep() {
		if (productForm.querySelector('[data-variant-select-discontinued]')) return false;

		if (isDesktop()) markMissingSelects();

		var variantSelect = getFirstUnpickedVariantSelect();
		if (variantSelect) {
			openVariantStep(variantSelect);
			return true;
		}

		var addonSelect = getUnchosenAddonSelect();
		if (addonSelect) {
			openAddonStep(addonSelect);
			return true;
		}

		return false;
	}

	btn.addEventListener('click', (event) => {
		if (event.target.closest('[data-signup-button]')) return;

		if (openNextStep()) {
			event.preventDefault();
		}
	});

	return {
		openNextStep: openNextStep,
	};

})();